
import React, { FC, useEffect, useRef, useState } from "react";
import { FormBox } from "./FormBox"
import { TableBox } from "./TableBox"
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { AddGoodsModal } from "./AddGoodsModal";
import { AddSupplierModal } from "./AddSupplierModal";
import { HistoryModel } from "@/views/historyModel";
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { SupplierHistoryModel } from "@/views/commonModule/supplierHistoryModel"
import { TabsBox } from "./TabsBox";
import ChangeSupplier from "./changeSupplier";
export const PurchaseEnquiryDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const IFormRef = useRef<IYhFormRef>();
    const {
        historyVisible, setHistoryVisible,
        historyRow,
        supplierHistoryModel,
        detailAddForm, detailEditForm, detailLookForm,
        supplierHistoryVisible, setSupplierHistoryVisible,
    } = usePurchaseEnquiryDetailsModel();
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    return (
        <>
            <FormBox {...detailsInfo} IFormRef={IFormRef} />
            <TabsBox {...detailsInfo} />
            <AddGoodsModal {...detailsInfo} />
            <AddSupplierModal {...detailsInfo} />
            <HistoryModel
                visible={historyVisible}
                materialCode={historyRow.materialCode as string}
                materialName={historyRow.materialName as string}
                onCancel={() => setHistoryVisible(false)}
            />
            <SupplierHistoryModel
                visible={supplierHistoryVisible}
                name={supplierHistoryModel.supplierName}
                onCancel={() => setSupplierHistoryVisible(false)}
            />
            <ChangeSupplier {...detailsInfo} />
        </>
    )
}